<template>
  <div>
    <b-modal v-model="showSiteMap" hide-header hide-footer centered size="xl">
      <b-carousel
        id="carousel-1"
        :controls="siteMap.length > 1"
        indicators
        :interval="0"
      >
        <b-carousel-slide v-for="map in siteMap" :key="map.id">
          <template v-slot:img>
            <div v-if="siteMap.length !== 0">
              <b-img
                class="w-100"
                rounded
                alt="Site Map"
                :src="map.url"
              ></b-img>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-modal>

    <b-container class="p-relative">
      <div
        class="header-text-container"
        :style="isMobile ? 'top: 75px' : ''"
        v-if="showHeader"
      >
        <div class="header-text">Users</div>
      </div>
    </b-container>

    <div class="px-3 mobile__search" v-show="isMobile">
      <search-all
        @open="showHeader = isMobile ? false : true"
        @close="showHeader = true"
      />
    </div>

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <div class="subheader-container">
      <b-container class="p-relative">
        <div class="subheader-text-container" v-if="!isMobile">
          <b-breadcrumb
            :items="items"
            class="pl-0 bg-transparent"
          ></b-breadcrumb>
        </div>
      </b-container>
    </div>

    <b-container class="py-0 pt-5" :class="isMobile ? '' : 'custom-container'">
      <b-form-group id="input-group-full-name" class="col-12">
        <i
          class="clearable"
          v-show="form.email && editing"
          @click="form.email = ''"
          >&times;</i
        >

        <b-form-input
          id="input-full-name"
          ref="refFullName"
          v-model="form.email"
          class="input-effect"
          :class="form.email ? 'has-content' : ''"
          :disabled="!editing"
          type="text"
          required
          aria-describedby="input-full-name-feedback"
        ></b-form-input>
        <label>Email</label>

        <div class="input-error" v-if="form.$getError('email')">
          {{ form.$getError('email')[0] }}
        </div>
      </b-form-group>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SearchAll from '@/components/buttons/SearchAll'
import { findIndex } from 'lodash'
import ZoomAndPan from '@/utils/ZoomAndPan'

export default {
  components: {
    SearchAll
  },

  data() {
    return {
      addBoard: false,
      currentBoard: 0,
      boardClass: 'justify-content-center',
      loading: false,
      clicked: false,
      showSiteMap: false,
      showHeader: true,
      itemss: [
        { age: 40, first_name: 'Dickerson', last_name: 'Macdonald' },
        { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        { age: 38, first_name: 'Jami', last_name: 'Carney' }
      ]
    }
  },

  computed: {
    ...mapState({
      boardList: state => state.site.boardList,
      boardListMeta: state => state.site.boardListMeta,
      site: state => state.site.siteDetails
    }),

    listLimit() {
      return this.isMobile ? 1 : 5
    },

    items() {
      return [
        { text: 'Home', href: '/dashboard' },
        { text: 'Users', href: '#' }
      ]
    },

    siteMap() {
      return this.site ? this.site.site_map : []
    },

    showToolTip() {
      return this.siteMap.length === 0
    }
  },

  methods: {
    ...mapActions({
      getSite: 'site/getSiteDetails',
      getSiteBoards: 'site/getSiteBoards'
    }),

    ...mapMutations({
      clearSiteBoards: 'site/clearSiteBoardList'
    }),

    addDistributionBoard() {
      this.$root.$emit('showPlusSign', true)
      window.scrollTo({
        top: window.innerHeight / 2,
        left: 0,
        behavior: 'smooth'
      })
    },

    autoScrollToCenter() {
      let t = this
      setTimeout(function() {
        t.boardClass =
          t.$refs.boardContainer.scrollWidth <=
          t.$refs.boardContainer.clientWidth
            ? 'justify-content-center'
            : ''
        t.$refs.boardContainer.scrollLeft =
          t.$refs.boardContainer.scrollWidth / 2
      }, 100)
    },

    onClickMainBoard(index) {
      this.$root.$emit('showPlusSign', false)
      this.currentBoard = index
      this.autoScrollToCenter()
    },

    loadPrevious() {
      if (this.boardListMeta.current_page > 1) {
        this.fetchSiteBoards(this.boardListMeta.current_page - 1)
      }
    },

    loadNext() {
      if (this.boardListMeta.current_page < this.boardListMeta.last_page) {
        this.fetchSiteBoards(this.boardListMeta.current_page + 1)
      }
    },

    async fetchSiteBoards(page = 1) {
      if (this.loading) return
      this.loading = true
      await this.getSiteBoards({
        site_id: this.$route.params.id,
        page: page,
        limit: this.listLimit
      })
      this.loading = false

      if (!this.clicked && this.$route.params.activeBoard) {
        const index = findIndex(this.boardList, {
          board_id: this.$route.params.activeBoard
        })
        if (index === -1) {
          this.fetchSiteBoards(this.boardListMeta.current_page + 1)
        } else {
          this.currentBoard = index
          this.clicked = true
        }
      }

      this.autoScrollToCenter()
    }
  },

  created() {
    this.getSite(this.$route.params.id)
    this.fetchSiteBoards()
  },

  mounted() {
    ZoomAndPan(this.$refs.boardContainer)
  }
}
</script>

<style lang="scss" scoped>
.col {
  padding: 0 12px;
  margin-bottom: 30px;
}
.btn {
  height: 46px;
  background: #ffffff33 0% 0% no-repeat padding-box;
}
.btn-outline-primary:hover {
  color: #106fdc;
}
.add-btn {
  height: 40px;
  width: 155px;
}
.load-btn {
  background: #f2f3f6;
  padding: 0 10px;
  border-radius: 4px;
  height: 40px;
}
.small-btn {
  width: 45%;
  font-size: 12px;
}
.empty-container {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border-radius: 10px;
  height: 240px;
  text-align: center;
  padding-top: 85px;
  box-shadow: none;
}
.header-actions-container {
  position: absolute;
  color: white;
  top: 100px;
  right: 10px;
  z-index: 2;
  text-shadow: 0px 4px 8px #00000066;
}
.header-text-container {
  position: absolute;
  color: white;
  top: 100px;
  z-index: 2;
}
.header-text {
  font-size: 28px;
  font-weight: bold;
}
.subheader-container {
  background-color: #f5f5f5;
  height: 75px;
}
.subheader-text {
  font-size: 12px;
}
.subheader-text-container {
  position: absolute;
  top: 15px;
}
.subheader-actions-container {
  position: absolute;
  top: 15px;
  right: 15px;
  text-shadow: 0px 4px 8px #00000066;
}
.cover-image {
  width: 100%;
  min-height: 180px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}
.cover-overlay {
  width: 100%;
  min-height: 180px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
.board-tree {
  max-height: 600px;
  overflow: auto;
  border: 1px solid #d6d6d6;
  background: #f7f7f7;
}
.breadcrumb-item {
  font-weight: bold;
}
.breadcrumb-item + .breadcrumb-item.active {
  font-weight: normal;
}
.breadcrumb-item + .breadcrumb-item::before {
  content: '\203A';
}
.mobile__search {
  position: absolute;
  right: 0px;
  top: 72px;
  z-index: 2;
}
</style>
